import { Injectable } from '@angular/core';
import {
  TIME_HORIZON_KEY_1Y,
  TIME_HORIZON_KEY_2Y,
  TIME_HORIZON_KEY_3Y,
  TIME_HORIZON_KEY_4Y,
  TIME_HORIZON_KEY_5Y,
} from '../../constants';
import { TimeHorizonKey } from '../result-data/result-data.service';

const toYearKeys = (n: number) =>
  Array.from({ length: n }, (_, i) => `y${i + 1}` as const);

const makeConfig = (
  number: number,
  id: `${number}Y`,
  createYearLabels: (n: number) => string[]
) => {
  const labels = createYearLabels(number);
  return {
    number,
    id,
    labels,
    displayedColumns: ['name', ...labels],
    yearKeys: toYearKeys(number),
  } satisfies TimeHorizonConfig;
};

// describe horizons once
const HORIZONS = [
  { n: 1, id: '1Y' as const, key: TIME_HORIZON_KEY_1Y },
  { n: 2, id: '2Y' as const, key: TIME_HORIZON_KEY_2Y },
  { n: 3, id: '3Y' as const, key: TIME_HORIZON_KEY_3Y },
  { n: 4, id: '4Y' as const, key: TIME_HORIZON_KEY_4Y },
  { n: 5, id: '5Y' as const, key: TIME_HORIZON_KEY_5Y },
] as const;

export interface TimeHorizonConfig {
  number: number;
  id: string; // e.g. '1Y', '5Y', '3Y'
  labels: string[]; // e.g. ['Y1', 'Y2', 'Y3']
  displayedColumns: string[]; // e.g. ['name', 'y1', 'y2', 'y3']
  yearKeys: string[]; // e.g. ['y1', 'y2', 'y3']
}

@Injectable({
  providedIn: 'root',
})
export class TimeHorizonService {
  constructor() {}

  private configs: Record<string, TimeHorizonConfig> = HORIZONS.reduce(
    (acc, { n, id, key }) => {
      acc[key] = makeConfig(n, id, this._createYearLabels.bind(this));
      return acc;
    },
    {} as Record<string, TimeHorizonConfig>
  );

  getConfig(timeHorizonId: TimeHorizonKey): TimeHorizonConfig {
    return this.configs[timeHorizonId] ?? this.configs[TIME_HORIZON_KEY_5Y];
  }

  getAvailableHorizons(): TimeHorizonConfig[] {
    return Object.values(this.configs);
  }

  private _createYearLabels(yearAmount: number): string[] {
    let result = [];

    for (let i = 0; i < yearAmount; i++) {
      result.push('Année ' + (i + 1));
    }

    return result;
  }
}
